import { type } from '@/utils/type'

export const UI_TOGGLE_GDB_CONSOLE_FILTER = type('UI_TOGGLE_GDB_CONSOLE_FILTER')
export const UI_SET_GDB_CONSOLE_FILTER = type('UI_SET_GDB_CONSOLE_FILTER')
export const UI_SET_CONSOLE_AUTOSCROLL = type('UI_SET_CONSOLE_AUTOSCROLL')
export const UI_SET_CONSOLE_SCROLLINDEX = type('UI_SET_CONSOLE_SCROLLINDEX')

export const UI_TOGGLE_DRAWER_VISIBILITY = type('UI_TOGGLE_DRAWER_VISIBILITY')
export const UI_SET_DRAWER_VISIBILITY = type('UI_SET_DRAWER_VISIBILITY')

export const UI_SET_SOUND_NOTIFICATION = type('UI_SET_SOUND_NOTIFICATION')

export const UI_TOGGLE_DARKMODE = type('UI_TOGGLE_DARKMODE')

export const UI_SET_KEYPRESS = type('UI_SET_KEYPRESS')

export const UI_TOGGLE_RIGHT_DRAWER_VISIBILITY = type('UI_TOGGLE_RIGHT_DRAWER_VISIBILITY')
export const UI_SET_RIGHT_DRAWER_VISIBILITY = type('UI_SET_RIGHT_DRAWER_VISIBILITY')

export const UI_RESET_SMARTPLANNING_FILTER = type('UI_RESET_SMARTPLANNING_FILTER')

export const UI_TOGGLE_MISSION_MAP_VISIBILITY = type('UI_TOGGLE_MISSION_MAP_VISIBILITY')
export const UI_SET_MISSION_MAP_VISIBILITY = type('UI_SET_MISSION_MAP_VISIBILITY')
export const UI_SHOW_ALL_DRAWER_MISSION_MAP = type('UI_SHOW_ALL_DRAWER_MISSION_MAP')
export const UI_HIDE_ALL_DRAWER_MISSION_MAP = type('UI_HIDE_ALL_DRAWER_MISSION_MAP')

export const UI_SHOW_ALL_SIMULATION_MISSION_MAP = type('UI_SHOW_ALL_SIMULATION_MISSION_MAP')
export const UI_HIDE_ALL_SIMULATION_MISSION_MAP = type('UI_HIDE_ALL_SIMULATION_MISSION_MAP')

export const UI_TOGGLE_ONGOING_MISSION_VIEW = type('UI_TOGGLE_ONGOING_MISSION_VIEW')
export const UI_ACTIVE_ONGOING_MISSION_VIEW = type('UI_ACTIVE_ONGOING_MISSION_VIEW')
export const UI_ACTIVE_SIMULATED_MISSION_VIEW = type('UI_ACTIVE_SIMULATED_MISSION_VIEW')
export const UI_UNACTIVE_ONGOING_MISSION_VIEW = type('UI_UNACTIVE_ONGOING_MISSION_VIEW')
export const UI_UNACTIVE_SIMULATED_MISSION_VIEW = type('UI_UNACTIVE_SIMULATED_MISSION_VIEW')

export const UI_SET_MINDATE_MISSION_FILTER = type('UI_SET_MINDATE_MISSION_FILTER')
export const UI_UNSET_MINDATE_MISSION_FILTER = type('UI_UNSET_MINDATE_MISSION_FILTER')
export const UI_SET_MAXDATE_MISSION_FILTER = type('UI_SET_MAXDATE_MISSION_FILTER')
export const UI_UNSET_MAXDATE_MISSION_FILTER = type('UI_UNSET_MAXDATE_MISSION_FILTER')
export const UI_ADD_MISSIONS_FILTER = type('UI_ADD_MISSIONS_FILTER')
export const UI_REMOVE_MISSIONS_FILTER = type('UI_REMOVE_MISSIONS_FILTER')
export const UI_ADD_GLIDERS_FILTER = type('UI_ADD_GLIDERS_FILTER')
export const UI_REMOVE_GLIDERS_FILTER = type('UI_REMOVE_GLIDERS_FILTER')
export const UI_ADD_MISSIONFLEET_FILTER = type('UI_ADD_MISSIONFLEET_FILTER')
export const UI_REMOVE_MISSIONFLEET_FILTER = type('UI_REMOVE_MISSIONFLEET_FILTER')

export const UI_SELECT_MAP_BASELAYER = type('UI_SELECT_MAP_BASELAYER')
export const UI_UNSELECT_MAP_BASELAYER = type('UI_UNSELECT_MAP_BASELAYER')

export const UI_TOGGLE_SIMULATION_INFOS_VISIBILITY = type('UI_TOGGLE_SIMULATION_INFOS_VISIBILITY')
export const UI_TOGGLE_MISSION_INFOS_VISIBILITY = type('UI_TOGGLE_MISSION_INFOS_VISIBILITY')

export const UI_ENSURE_MISSION_STATE = type('UI_ENSURE_MISSION_STATE')
export const UI_ENSURE_MISSIONPLAN_STATE = type('UI_ENSURE_MISSIONPLAN_STATE')
export const UI_ENSURE_FLEET_STATE = type('UI_ENSURE_FLEET_STATE')
export const UI_ENSURE_GRA_STATE = type('UI_ENSURE_GRA_STATE')
export const UI_ENSURE_MAP_STATE = type('UI_ENSURE_MAP_STATE')
export const UI_ENSURE_FLEETMAP_STATE = type('UI_ENSURE_FLEETMAP_STATE')
export const UI_ENSURE_ALL_GRA_STATE = type('UI_ENSURE_ALL_GRA_STATE')
export const UI_ENABLE_CONSOLE_MSG = type('UI_ENABLE_CONSOLE_MSG')

export const UI_ENSURE_MISSIONGLOBAL_STATE = type('UI_ENSURE_MISSIONGLOBAL_STATE')

export const UI_MISSIONPLAN_SET_HOVER_WPT_ID = type('UI_MISSIONPLAN_SET_HOVER_WPT_ID')
export const UI_MISSIONPLAN_SET_HOVER_STEP_ID = type('UI_MISSIONPLAN_SET_HOVER_STEP_ID')
export const UI_MISSIONPLAN_SET_HOVER_PRF_ID = type('UI_MISSIONPLAN_SET_HOVER_PRF_ID')
export const UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL = type('UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL')
export const UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL_SCI = type('UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL_SCI')
export const UI_MISSIONPLAN_SET_CURRENT_EDIT_STEP = type('UI_MISSIONPLAN_SET_CURRENT_EDIT_STEP')
export const UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT = type('UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT')
export const UI_MISSIONPLAN_SET_CURRENT_EDIT_SENSOR = type('UI_MISSIONPLAN_SET_CURRENT_EDIT_SENSOR')
export const UI_MISSIONPLAN_SET_DRAWMOD = type('UI_MISSIONPLAN_SET_DRAWMOD')
export const UI_MISSIONPLAN_SET_SHOW_GLOBALWPT = type('UI_MISSIONPLAN_SET_SHOW_GLOBALWPT')
export const UI_MISSIONPLAN_SET_LASTACTION_ID = type('UI_MISSIONPLAN_SET_LASTACTION_ID')
export const UI_MISSIONPLAN_SET_SHOWALL_VALIDATION = type('UI_MISSIONPLAN_SET_SHOWALL_VALIDATION')
export const UI_MISSIONPLAN_SET_MISSIONPLAN = type('UI_MISSIONPLAN_SET_MISSIONPLAN')

export const UI_LOAD_CONSOLE_MSG_REQUEST = type('UI_LOAD_CONSOLE_MSG_REQUEST')
export const UI_LOAD_CONSOLE_MSG_ERROR = type('UI_LOAD_CONSOLE_MSG_ERROR')
export const UI_LOAD_CONSOLE_MSG_SUCCESS = type('UI_LOAD_CONSOLE_MSG_SUCCESS')

export const UI_CENTER_MAP = type('UI_CENTER_MAP')
export const UI_ZOOM_MAP = type('UI_ZOOM_MAP')
export const UI_POS_MAP = type('UI_POS_MAP')
export const UI_REFRESH_BEST_FIT_MAP = type('UI_REFRESH_BEST_FIT_MAP')
export const UI_SELECT_MISSION_MAP = type('UI_SELECT_MISSION_MAP')
export const UI_SELECT_FLEET_MAP = type('UI_SELECT_FLEET_MAP')
export const UI_SELECT_SIMULATION_MAP = type('UI_SELECT_SIMULATION_MAP')

export const UI_SELECT_TIMELINE_MISSION_INDEX = type('UI_SELECT_TIMELINE_MISSION_INDEX')
export const UI_SELECT_LAST_TIMELINE_MISSION_INDEX = type('UI_SELECT_LAST_TIMELINE_MISSION_INDEX')
export const UI_SELECT_RANGETIMELINE_MISSION_INDEX = type('UI_SELECT_RANGETIMELINE_MISSION_INDEX')

export const UI_SET_ITEM_MAP_STYLE = type('UI_SET_ITEM_MAP_STYLE')
export const UI_SET_DEFAULT_MAP_STYLE = type('UI_SET_DEFAULT_MAP_STYLE')

export const UI_TOGGLE_HEADING_VISIBILITY = type('UI_TOGGLE_HEADING_VISIBILITY')
export const UI_SHOW_HEADING = type('UI_SHOW_HEADING')
export const UI_HIDE_HEADING = type('UI_HIDE_HEADING')

export const UI_TOGGLE_OCEANCURRENT = type('UI_TOGGLE_OCEANCURRENT')
export const UI_SHOW_OCEANCURRENT = type('UI_SHOW_OCEANCURRENT')
export const UI_HIDE_OCEANCURRENT = type('UI_HIDE_OCEANCURRENT')
export const UI_SET_BORNE_MIN_CURRENT = type('UI_SET_BORNE_MIN_CURRENT')
export const UI_SET_BORNE_MAX_CURRENT = type('UI_SET_BORNE_MAX_CURRENT')
export const UI_SET_ZOOM_CURRENT = type('UI_SET_ZOOM_CURRENT')

export const UI_TOGGLE_DRIFT_VISIBILITY = type('UI_TOGGLE_DRIFT_VISIBILITY')
export const UI_SHOW_DRIFT = type('UI_SHOW_DRIFT')
export const UI_HIDE_DRIFT = type('UI_HIDE_DRIFT')

export const UI_TOGGLE_MORE_NMEA_VISIBILITY = type('UI_TOGGLE_MORE_NMEA_VISIBILITY')
export const UI_TOGGLE_REMAINING_NAV_VISIBILITY = type('UI_TOGGLE_REMAINING_NAV_VISIBILITY')

export const UI_TOGGLE_PATH_VISIBILITY = type('UI_TOGGLE_PATH_VISIBILITY')
export const UI_SHOW_PATH = type('UI_SHOW_PATH')
export const UI_HIDE_PATH = type('UI_HIDE_PATH')

export const UI_TOGGLE_MISSIONPLAN_VISIBILITY = type('UI_TOGGLE_MISSIONPLAN_VISIBILITY')
export const UI_SHOW_MISSIONPLAN = type('UI_SHOW_MISSIONPLAN')
export const UI_HIDE_MISSIONPLAN = type('UI_HIDE_MISSIONPLAN')

export const UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY = type('UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY')
export const UI_SHOW_MISSIONPLAN_VALIDATION = type('UI_SHOW_MISSIONPLAN_VALIDATION')
export const UI_HIDE_MISSIONPLAN_VALIDATION = type('UI_HIDE_MISSIONPLAN_VALIDATION')

export const UI_TOGGLE_MISSIONLAYER_VISIBILITY = type('UI_TOGGLE_MISSIONLAYER_VISIBILITY')
export const UI_SHOW_MISSIONLAYER = type('UI_SHOW_MISSIONLAYER')
export const UI_HIDE_MISSIONLAYER = type('UI_HIDE_MISSIONLAYER')

export const UI_TOGGLE_ENDMISSION_SIMULATION_VISIBILITY = type('UI_TOGGLE_ENDMISSION_SIMULATION_VISIBILITY')
export const UI_SHOW_ENDMISSION_SIMULATION = type('UI_SHOW_ENDMISSION_SIMULATION')
export const UI_HIDE_ENDMISSION_SIMULATION = type('UI_HIDE_ENDMISSION_SIMULATION')

export const UI_SET_ENDMISSION_SIMULATION_OPACITY = type('UI_SET_ENDMISSION_SIMULATION_OPACITY')

export const UI_TOGGLE_CYCLE_VISIBILITY = type('UI_TOGGLE_CYCLE_VISIBILITY')
export const UI_SHOW_CYCLE = type('UI_SHOW_CYCLE')
export const UI_HIDE_CYCLE = type('UI_HIDE_CYCLE')

export const UI_TOGGLE_AIS_VISIBILITY = type('UI_TOGGLE_AIS_VISIBILITY')

export const UI_TOGGLE_WAYPOINT_VISIBILITY = type('UI_TOGGLE_WAYPOINT_VISIBILITY')
export const UI_SHOW_WAYPOINT = type('UI_SHOW_WAYPOINT')
export const UI_HIDE_WAYPOINT = type('UI_HIDE_WAYPOINT')

export const UI_TOGGLE_LAYERMAP_VISIBILITY = type('UI_TOGGLE_LAYERMAP_VISIBILITY')
export const UI_SHOW_LAYERMAP = type('UI_SHOW_LAYERMAP')
export const UI_HIDE_LAYERMAP = type('UI_HIDE_LAYERMAP')

export const UI_SET_MISSIONLAYERMAP_OPACITY = type('UI_SET_MISSIONLAYERMAP_OPACITY')

export const UI_TOGGLE_GRATICULE_VISIBILITY = type('UI_TOGGLE_GRATICULE_VISIBILITY')
export const UI_SHOW_GRATICULE = type('UI_SHOW_GRATICULE')
export const UI_HIDE_GRATICULE = type('UI_HIDE_GRATICULE')

export const UI_SET_LAYERMAP_OPACITY = type('UI_SET_LAYERMAP_OPACITY')

export const UI_SET_LAYERMAP_CONFIG = type('UI_SET_LAYERMAP_CONFIG')

export const UI_SET_COORDFORMATER = type('UI_SET_COORDFORMATER')

export const UI_SET_MEASURETOOL = type('UI_SET_MEASURETOOL')

export const UI_SET_MOVABLE_DIALOG_VISIBILITY = type('UI_SET_MOVABLE_DIALOG_VISIBILITY')
export const UI_SHOW_DEPTH_PROFILE_DIALOG = type('UI_SHOW_DEPTH_PROFILE_DIALOG')
export const UI_SHOW_CHART_CONFIG_DIALOG = type('UI_SHOW_CHART_CONFIG_DIALOG')

export const UI_SET_INFOS_DIALOG_VISIBILITY = type('UI_SET_INFOS_DIALOG_VISIBILITY')
export const UI_SHOW_INFOS_DIALOG = type('UI_SHOW_INFOS_DIALOG')

export const UI_SET_GRA_ABSCISSE = type('UI_SET_GRA_ABSCISSE')
export const UI_SET_GRA_ORDONNEE = type('UI_SET_GRA_ORDONNEE')
export const UI_SET_GRA_COLOR = type('UI_SET_GRA_COLOR')
export const UI_SET_GRA_TRANSFORM = type('UI_SET_GRA_TRANSFORM')
export const UI_SET_GRA_ZOOM = type('UI_SET_GRA_ZOOM')
export const UI_SET_GRA_DATA = type('UI_SET_GRA_DATA')
export const UI_SET_SCI_HOVERDATA = type('UI_SET_SCI_HOVERDATA')
export const UI_SET_NAV_HOVERDATA = type('UI_SET_NAV_HOVERDATA')
export const UI_SET_SIMU_HOVERDATA = type('UI_SET_SIMU_HOVERDATA')
export const UI_SET_GRA_POINT_SIZE = type('UI_SET_GRA_POINT_SIZE')
export const UI_SAVE_CHART_CONFIG = type('UI_SAVE_CHART_CONFIG')
export const UI_LOAD_CHART_CONFIG = type('UI_LOAD_CHART_CONFIG')
export const UI_TOGGLE_GRA_VORONOI = type('UI_TOGGLE_GRA_VORONOI')
export const UI_SET_GRA_CONFIG = type('UI_SET_GRA_CONFIG')
export const UI_SET_GRA_STATE = type('UI_SET_GRA_STATE')
export const UI_OPEN_GRA_CONFIG = type('UI_OPEN_GRA_CONFIG')
export const UI_RESET_UISTATE = type('UI_RESET_UISTATE')
export const UI_REFRESH_COMPONENT = type('UI_REFRESH_COMPONENT')
export const UI_SET_NMEA_GRA_CONFIG = type('UI_SET_NMEA_GRA_CONFIG')
export const UI_SET_SIMULATION_GRA_TYPE = type('UI_SET_SIMULATION_GRA_TYPE')

export const UI_SET_REDIRECT_PATH = type('UI_SET_REDIRECT_PATH')

export const UI_CLOSE_SNACKBAR = type('UI_CLOSE_SNACKBAR')
export const UI_ADD_SNACK_MESSAGE = type('UI_ADD_SNACK_MESSAGE')

export const UI_REFRESH_NAV_GRAPH_CACHE = type('UI_REFRESH_NAV_GRAPH_CACHE')
export const UI_REFRESH_SCI_GRAPH_CACHE = type('UI_REFRESH_SCI_GRAPH_CACHE')
export const UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY = type('UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY')

export const UI_SET_PLANIFVIEW_MODE = type('UI_SET_PLANIFVIEW_MODE')

export const UI_SET_GRAPH_HOVER_DATA = type('UI_SET_GRAPH_HOVER_DATA')
export const UI_SET_GRAPH_HOVER_DATA_VISIBILITY = type('UI_SET_GRAPH_HOVER_DATA_VISIBILITY')

export const UI_SET_LEFTPANEL_SIZE = type('UI_SET_LEFTPANEL_SIZE')
export const UI_NAVTO_DETAIL = type('UI_NAVTO_DETAIL')
export const UI_UNSELECT_TAB = type('UI_UNSELECT_TAB')
export const UI_CLOSE_TAB = type('UI_CLOSE_TAB')
export const UI_MOVE_TAB = type('UI_MOVE_TAB')
export const UI_RENAME_DETAIL = type('UI_RENAME_DETAIL')

export const UI_FLEET_LOGBOOK_REQUEST = type('UI_FLEET_LOGBOOK_REQUEST')
export const UI_FLEET_LOGBOOK_SUCCESS = type('UI_FLEET_LOGBOOK_SUCCESS')
export const UI_FLEET_LOGBOOK_ERROR = type('UI_FLEET_LOGBOOK_ERROR')
export const UI_FLEET_LOGBOOK_ITEM_REQUEST = type('UI_FLEET_LOGBOOK_ITEM_REQUEST')
export const UI_FLEET_LOGBOOK_ITEM_SUCCESS = type('UI_FLEET_LOGBOOK_ITEM_SUCCESS')
export const UI_FLEET_LOGBOOK_ITEM_ERROR = type('UI_FLEET_LOGBOOK_ITEM_ERROR')
export const UI_FLEET_LOGBOOK_SEND_MESSAGE_REQUEST = type('UI_FLEET_LOGBOOK_SEND_MESSAGE_REQUEST')
export const UI_FLEET_LOGBOOK_SEND_MESSAGE_ERROR = type('UI_FLEET_LOGBOOK_SEND_MESSAGE_ERROR')
export const UI_FLEET_LOGBOOK_UPDATE_MESSAGE_REQUEST = type('UI_FLEET_LOGBOOK_UPDATE_MESSAGE_REQUEST')
export const UI_FLEET_LOGBOOK_UPDATE_MESSAGE_ERROR = type('UI_FLEET_LOGBOOK_UPDATE_MESSAGE_ERROR')
